import React from 'react';
import { Rocket, Message, Ad, Desapegar } from './animations';
import { Menu } from '@olxbr/ds-icons';
import { sendClickEvent } from '../Header/utils/sendClickEvent';
import * as Styles from './styles';
import Link from '../Link';
import Text from '../Text';
/**
 * Componente Navbar do Design System OLX
 */
export const Navbar = ({ pageActive, onClickAccount, isLogged }) => {
    const pageActiveClassName = (page) => (pageActive[page] ? 'active' : '');
    return (React.createElement(Styles.NavbarWrapper, { "aria-label": "Menu secund\u00E1rio", "data-ds-component": "DS-Navbar", className: "navbar-wrapper" },
        React.createElement("ul", { className: "navbar-items" },
            React.createElement("li", { className: `navbar-item ${pageActiveClassName('explore')}` },
                React.createElement(Link, { dsParentName: "Navbar", variant: "grey", href: "https://www.olx.com.br", className: "link", onClick: () => sendClickEvent('listing', 'navbar') },
                    React.createElement(Rocket, { active: pageActive.explore }),
                    React.createElement(Text.Caption, { className: "caption" }, "Explorar"))),
            React.createElement("li", { className: `navbar-item ${pageActiveClassName('messages')}` },
                React.createElement(Link, { dsParentName: "Navbar", variant: "grey", href: "https://conta.olx.com.br/chats", className: "link", onClick: () => sendClickEvent('chat', 'navbar') },
                    React.createElement(Message, { active: pageActive.messages }),
                    React.createElement(Text.Caption, { className: "caption center-links" }, "Mensagens"))),
            React.createElement("li", { className: `navbar-item ${pageActiveClassName('desapegar')}` },
                React.createElement(Link, { dsParentName: "Navbar", variant: "grey", href: "https://www2.olx.com.br/desapega", className: "link", onClick: () => sendClickEvent('ad_insert', 'navbar') },
                    React.createElement(Desapegar, { active: pageActive.desapegar }),
                    React.createElement(Text.Caption, { className: "caption" }, "Desapegar"))),
            React.createElement("li", { className: `navbar-item ${pageActiveClassName('ads')}` },
                React.createElement(Link, { dsParentName: "Navbar", variant: "grey", href: "https://conta.olx.com.br/anuncios", className: "link", onClick: () => sendClickEvent('my_ads', 'navbar') },
                    React.createElement(Ad, { active: pageActive.ads }),
                    React.createElement(Text.Caption, { className: "caption" }, "An\u00FAncios"))),
            React.createElement("li", { className: `navbar-item ${pageActiveClassName('account')}` },
                React.createElement("button", { "data-ds-component": "DS-Navbar-Button", className: "link", onClick: () => {
                        !!onClickAccount && onClickAccount();
                        sendClickEvent(isLogged ? 'conta' : 'login', 'navbar');
                    } },
                    React.createElement(Menu, null),
                    React.createElement(Text.Caption, { className: "caption" }, "Conta"))))));
};
Navbar.displayName = 'Navbar';
